var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 10.0007V14.1673C18.3327 16.6673 16.666 18.334 14.166 18.334H5.83268C3.33268 18.334 1.66602 16.6673 1.66602 14.1673V10.0007C1.66602 7.73398 3.03268 6.15065 5.15768 5.88398C5.37435 5.85065 5.59935 5.83398 5.83268 5.83398H14.166C14.3827 5.83398 14.591 5.84231 14.791 5.87564C16.941 6.12564 18.3327 7.71732 18.3327 10.0007Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7935 5.87435C14.5935 5.84101 14.3852 5.83269 14.1685 5.83269H5.83516C5.60182 5.83269 5.37682 5.84936 5.16016 5.88269C5.27682 5.64936 5.44349 5.43269 5.64349 5.23269L8.35182 2.51602C9.49349 1.38268 11.3435 1.38268 12.4852 2.51602L13.9435 3.99103C14.4768 4.51603 14.7602 5.18268 14.7935 5.87435Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 10.416H15.8327C14.916 10.416 14.166 11.166 14.166 12.0827C14.166 12.9993 14.916 13.7493 15.8327 13.7493H18.3327",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.46fdbe1f94e0d4fdc31a998c4ea53b94.svg";
export { ForwardRef as ReactComponent };